import { render } from "./StudioView.vue?vue&type=template&id=2b08507c"
import script from "./StudioView.vue?vue&type=script&lang=js"
export * from "./StudioView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__